import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入Ant-vue组件
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
// 引入图标库
import * as Icons from '@ant-design/icons-vue';

import { Tool } from "@/util/tool";
import { message } from 'ant-design-vue';

// 修改Axios的根URL
import axios from "axios";
// 配置axios的根请求目录
axios.defaults.baseURL = process.env.VUE_APP_SERVER;
/**
 * axios拦截器
 */
// axios请求拦截
axios.interceptors.request.use(function (config) {
    console.log('请求参数：', config);
    // 携带token请求后台接口
    const token = store.state.user.token;
    if (Tool.isNotEmpty(token)) {
        config.headers.token = token;
        // 为所有请求添加自定义请求头
        config.headers['wiki-token'] = token;
        console.log("请求headers增加token:", token);
        // 携带请求头
        config.headers.withCredentials = true
    }
    return config;
}, error => {
    return Promise.reject(error);
});
// axios响应拦截
axios.interceptors.response.use(function (response) {
    console.log('返回结果：', response);
    // {code: 41000, message: '令牌无效,请重新登录', data: null}
    if (response.data.code == 41000) {
        loginError()
    }
    return response;
}, error => {
    console.log('返回错误：', error);
    const response = error.response;
    const status = response.status;
    if (status === 401) {
        // 判断状态码是401 跳转到首页或登录页
        loginError()
    }
    return Promise.reject(error);
});

// 未登录或授权跳转首页
const loginError = () => {
    console.log("未登录，跳到首页");
    store.commit("removeUser", {});
    message.error("未登录或登录超时");
    router.push('/');
    window.location.reload();
}


// 使用组件 .use(Antd)
//createApp(App).use(store).use(router).use(Antd).mount('#app')

const app = createApp(App)
app.use(store).use(router).use(Antd).mount('#app')

// 全局使用图标
const icons: any = Icons;
for (const i in icons) {
    app.component(i, icons[i]);
}

// 引入阿里巴巴图标库，自定义 font 图标 #
import { createFromIconfontCN } from '@ant-design/icons-vue';
const IconFont = createFromIconfontCN({
    scriptUrl: '/js/iconfont.js', // 在 iconfont.cn 上生成下载到本地
});
// 全局注册组件
app.component('IconFont', IconFont)

// 测试环境变量
console.log('环境：', process.env.NODE_ENV)
console.log('服务：', process.env.VUE_APP_SERVER)
